import * as Yup from "yup";
import {toast} from "react-toastify";
import React, {useEffect, useRef, useState} from "react";
import messageTypes from "../../../constants/MessagesTypes";
import {Form} from "@unform/web";
import CustomButton from "../../../components/Form/Button";
import {Link, useHistory} from "react-router-dom";
import {BiArrowBack} from "react-icons/bi";
import {IoMdCheckmark} from "react-icons/io";
import Input from "../../../components/Form/Input";
import {useTranslation} from "react-i18next";
import {edit, getCurrencyPair, save} from "../../../services/CurrencyPair";
import DivDiagonal from "../../../components/DivDiagonal";
import {TradingListPageHeader, LoadingButton} from "../../Trading/styles";
import {
    TradingNewWrapper,
    ContentArea,
    TradingNewFormWrap,
    TradingFormCard,
    StyledFormWrapper,
    ButtonContainer,
} from "../../Trading/New/styles";

const backBtnStyle = {
    background: 'rgba(255, 255, 255, 0.05)',
    border: '2px solid rgba(255, 255, 255, 0.2)',
    color: '#e0e0e0',
    padding: '14px 28px',
    borderRadius: '10px',
    fontWeight: 600,
    transition: 'all 0.3s ease',
};

const saveBtnStyle = {
    background: 'linear-gradient(135deg, #f29205 0%, #ff6b35 100%)',
    border: 'none',
    color: '#ffffff',
    padding: '14px 32px',
    borderRadius: '10px',
    fontWeight: 600,
    boxShadow: '0 4px 15px rgba(242, 146, 5, 0.3)',
    transition: 'all 0.3s ease',
};

export default function NewCurrencyPair({match}) {
    const [fetching, setFetching] = useState(() => Boolean(match.params.id));
    const [submitting, setSubmitting] = useState(false);
    const [currencyPair, setCurrencyPair] = useState(0);
    const formRef = useRef(null);
    const history = useHistory();
    const { t } = useTranslation();

    async function handleSubmmit(data) {
        try {
            if (submitting) {
                return;
            }

            setSubmitting(true);
            formRef.current.setErrors({});
            const schema = Yup.object().shape({
                name: Yup.string().required(t('input_required')),
            });

            await schema.validate(data, {
                abortEarly: false,
            });

            const formData = new FormData();
            formData.append('name', data.name);
            const response = (currencyPair) ? await edit(currencyPair.id, formData) : await save(formData);

            if (response && response.status === 200) {
                toast.success(messageTypes.SUCCESS);
                history.push('/currency-pair');
            } else {
                toast.error(messageTypes.ERROR_SAVE);
            }
            setSubmitting(false);

        } catch (err) {
            setSubmitting(false);
            if (err instanceof Yup.ValidationError) {
                const validationErrors = {};
                err.inner.forEach((error) => {
                    validationErrors[error.path] = error.message;
                });
                formRef.current.setErrors(validationErrors);
                toast.warning(messageTypes.REQUIRED_FIELDS);
                return;
            }

            toast.error(messageTypes.ERROR);
        }
    }

    useEffect(() => {
        const id = match.params.id;
        if (!id) {
            setFetching(false);
            return;
        }
        setFetching(true);
        getCurrencyPair(id).then((data) => {
            setCurrencyPair(data);
        }).finally(() => setFetching(false));
    }, [match.params.id]);

    const isEditRoute = Boolean(match.params.id);

    return (
        <TradingNewWrapper>
            <DivDiagonal />
            <ContentArea>
                <TradingListPageHeader>
                    <h1>
                        <i className={isEditRoute ? 'fas fa-edit' : 'fas fa-plus'} aria-hidden="true"/>
                        {' '}
                        {isEditRoute ? t('currency_pair_edit_title') : t('currency_pair_new_title')}
                    </h1>
                </TradingListPageHeader>

                <TradingNewFormWrap>
                    {fetching ? (
                        <TradingFormCard>
                            <LoadingButton
                                className="btn text-capitalize font-weight-bold"
                                loading={fetching}
                                type="button"
                            >
                                {t('loading')}
                            </LoadingButton>
                        </TradingFormCard>
                    ) : (
                        <TradingFormCard>
                            <StyledFormWrapper>
                                <Form ref={formRef} onSubmit={handleSubmmit}>
                                    <Input
                                        type="text"
                                        name="name"
                                        defaultValue={currencyPair && currencyPair.name != null ? currencyPair.name : ''}
                                        label={t('currency_pair_field_name_label')}
                                        placeholder={t('currency_pair_field_name_label')}
                                    />
                                    <ButtonContainer>
                                        <Link to="/currency-pair">
                                            <CustomButton
                                                variant="outlined"
                                                className="font-weight-bold text-capitalize"
                                                style={backBtnStyle}
                                                startIcon={<BiArrowBack/>}
                                            >
                                                {t('btn_back')}
                                            </CustomButton>
                                        </Link>
                                        <CustomButton
                                            className="font-weight-bold text-capitalize"
                                            style={saveBtnStyle}
                                            loading={submitting}
                                            type="submit"
                                            startIcon={<IoMdCheckmark/>}
                                        >
                                            {t('btn_save')}
                                        </CustomButton>
                                    </ButtonContainer>
                                </Form>
                            </StyledFormWrapper>
                        </TradingFormCard>
                    )}
                </TradingNewFormWrap>
            </ContentArea>
        </TradingNewWrapper>
    );
}
